// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';

/**
 * 获取福豆项目列表
 */
export function getFudouProjectList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/fudou/project/index',
    method: 'GET',
    params: params
  });
}

/**
 * 获取项目列表
 */
export function getProjectList(params) {
  return request({
    url: '/admin/welfare/project/list',
    method: 'get',
    params: params
  });
}

/**
 * 添加或更新项目
 */
export function saveProject() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/welfare/project/save',
    method: 'POST',
    data: data
  });
}

/**
 * 删除项目
 */
export function deleteProject(id) {
  return request({
    url: "/admin/welfare/project/delete",
    method: 'DELETE',
    params: {
      id: id
    }
  });
}

/**
 * 获取项目详情
 */
export function getProjectDetail(id) {
  return request({
    url: '/admin/fudou/project/detail',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 修改项目状态
 */
export function changeProjectStatus(data) {
  return request({
    url: '/admin/welfare/project/status',
    method: 'POST',
    params: data
  });
}

/**
 * 获取项目类型选项
 */
export function getProjectTypes() {
  return request({
    url: '/admin/welfare/project/types',
    method: 'GET'
  });
}

/**
 * 获取项目状态选项
 */
export function getProjectStatuses() {
  return request({
    url: '/admin/welfare/project/statuses',
    method: 'GET'
  });
}

/**
 * 获取活跃的客户列表
 */
export function getActiveCustomers() {
  return request({
    url: '/admin/customers/active-customers',
    method: 'get'
  });
}

/**
 * 获取卡片列表
 */
export function getCardList() {
  return request({
    url: '/admin/welfare/card/list',
    method: 'get',
    params: {
      page: 1,
      limit: 100
    }
  });
}

/**
 * 查看卡片详情
 */
export function getCardDetail(id) {
  return request({
    url: '/admin/welfare/project/card/detail',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取归属客户列表
 */
export function getCustomerList(params) {
  return request({
    url: '/admin/customers/active-customers',
    method: 'GET',
    params: params || {
      page: 1,
      limit: 100
    }
  });
}

/**
 * 获取小程序列表
 */
export function getMiniappList() {
  return request({
    url: '/admin/companyapp/autoList',
    method: 'get',
    params: {
      keyword: ''
    }
  });
}

/**
 * 导出项目列表
 */
export function exportFudouProjectList() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return request({
    url: '/admin/fudou/project/export',
    method: 'GET',
    params: params
  });
}

/**
 * 获取福豆项目详情
 */
export function getFudouProjectDetail(id) {
  return request({
    url: '/admin/fudou/project/detail',
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 获取项目福卡详情
 */
export function getProjectCardDetailApi(id) {
  return request({
    url: "admin/customer/integral-log/fudou-card/info/".concat(id),
    method: 'GET'
  });
}

/**
 * 获取福卡列表
 */
export function getCardListApi() {
  return request({
    url: 'admin/fudou/fucard/select',
    method: 'GET'
  });
}

/**
 * 变更福卡
 */
export function editFudouCard(data) {
  return request({
    url: 'admin/customer/integral-log/fudou-card/edit',
    method: 'POST',
    data: data
  });
}